import { Link } from 'react-router-dom';
import { FolderTree } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SectionCard } from './shared/SectionCard';
import { CobrosPorAgrupador } from './cobros/CobrosPorAgrupador';
import { CONTABILIDAD_ROUTES } from '../constants/routes';

export function CobrosPendientesPage() {
  return (
    <div className="space-y-5 p-2 sm:p-5">

      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-bold text-gray-900">Cobros Pendientes</h1>
        <Button asChild variant="outline" size="sm" className="gap-1.5 rounded-full">
          <Link to={CONTABILIDAD_ROUTES.AGRUPADORES} state={{ desde: 'cobros' }}>
            <FolderTree className="size-4" /> Agrupadores
          </Link>
        </Button>
      </div>

      <SectionCard className="overflow-hidden">
        <CobrosPorAgrupador />
      </SectionCard>
    </div>
  );
}
